import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { createRoot, Root } from 'react-dom/client';
import * as React from 'react';

const UserMenu = require('@react/components/navigation/UserMenu').default;

/**
 * Angular host for the React user menu in the bottom navigation.
 *
 * Angular keeps ownership of auth state and navigation; React owns the menu UI
 * and interaction so it can share the styling of the other React surfaces.
 */
@Component({
  selector: 'app-user-menu',
  template: '<div class="user-menu-react-root"></div>',
  styles: [
    `
      :host {
        display: inline-block;
        vertical-align: middle;
      }

      .user-menu-react-root {
        display: block;
      }
    `,
  ],
})
export class UserMenuBridgeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() userName = '';
  @Input() isAdmin = false;
  @Input() signOutLabel = 'Sign out';
  @Input() adminLabel = 'Admin';
  @Input() profileLabel = 'Profile settings';
  @Input() termsLabel = 'Terms of use';

  @Output() signOut = new EventEmitter<void>();
  @Output() openAdmin = new EventEmitter<void>();
  @Output() openProfile = new EventEmitter<void>();
  @Output() openTerms = new EventEmitter<void>();

  private reactRoot: Root | null = null;

  constructor(private el: ElementRef<HTMLElement>, private ngZone: NgZone) {}

  ngOnInit(): void {
    const container = this.el.nativeElement.querySelector('.user-menu-react-root');
    if (!container) return;

    this.reactRoot = createRoot(container);
    this.renderUserMenu();
  }

  ngOnChanges(): void {
    this.renderUserMenu();
  }

  ngOnDestroy(): void {
    this.reactRoot?.unmount();
    this.reactRoot = null;
  }

  private emit(output: EventEmitter<void>): void {
    this.ngZone.run(() => output.emit());
  }

  private renderUserMenu(): void {
    if (!this.reactRoot) return;

    this.reactRoot.render(
      React.createElement(UserMenu, {
        userName: this.userName,
        isAdmin: this.isAdmin,
        signOutLabel: this.signOutLabel,
        adminLabel: this.adminLabel,
        profileLabel: this.profileLabel,
        termsLabel: this.termsLabel,
        onSignOut: () => this.emit(this.signOut),
        onOpenAdmin: () => this.emit(this.openAdmin),
        onOpenProfile: () => this.emit(this.openProfile),
        onOpenTerms: () => this.emit(this.openTerms),
      })
    );
  }
}
